/* eslint-disable func-names */
import { calculateStatisticsData, FilterStatisticsResponse } from './statistics.worker';
import { isWebWorkerDefined } from '../../../../../config/config';
import SortAndFilterConfig from '../../../config/SortAndFilterConfig';
import { Data } from '../../../patterns/commands';
import { FilterTypes } from '..';

// eslint-disable-next-line consistent-return
export const statisticsWorkerFactory = () => (filterTypes: FilterTypes[], data: Data, config: SortAndFilterConfig) => {
    /**
     * Check if import.meta.url is available.
     */
    let isImportMetaUrlDefined = false;
    /**
     * Check if URL is available.
     */
    let isUrlDefined = false;

    if (isWebWorkerDefined) {
        isImportMetaUrlDefined = typeof import.meta !== 'undefined' && typeof import.meta.url !== 'undefined';
        isUrlDefined = typeof URL !== 'undefined';

        if (isImportMetaUrlDefined && isUrlDefined) {
            const worker = new Worker(new URL('./statistics.worker.ts', import.meta.url), { type: 'module' });
            return new Promise<FilterStatisticsResponse>((resolve, reject) => {
                try {
                    worker.onmessage = function (event) {
                        resolve(event.data);
                    };
                    worker.postMessage({ filterTypes, data, config });
                } catch (error) {
                    reject(error);
                }
            });
        }
    }
    return calculateStatisticsData;
};
